const fetchConfig = {
  method: "POST",
  headers: { "Content-Type": "application/json", Accept: `application/json` },
};
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);
const ART_FEE_VARIANT_ID = 50618492191020; // Art Fee product variant ID

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus");
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initLoading();
    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        async (parsedState) => {
          if (window.FoxThemeSettings.template === "cart") {
            this.renderContents(parsedState);
          }

          const cart = await FoxThemeCartHelpers.getState();
          if (cart) {
            this.cart = cart;
            FoxThemeCartHelpers.updateCartCount(cart.item_count);

            // Wait for Art Fee processing
            await this.handleArtFee(cart);

            this.classList.toggle("is-empty", cart.item_count === 0);
          }
        }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.body, {
      overlay: this.querySelector(".f-cart__items"),
    });
  }

  onChange(event) {
    if (event.target.getAttribute("name") !== "updates[]") return;
    this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${FoxThemeSettings.routes.cart_change_url}`, {
      ...fetchConfig,
      ...{ body },
    })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const updatedLine = this.querySelector(
              `#CartItem-${line}, #CartDrawer-Item-${line}`
          );

          const quantityElement = updatedLine.querySelector('[name="updates[]"]');
          const items = document.querySelectorAll(".f-cart-item");

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          const cartDrawer = document.querySelector("cart-drawer");

          this.classList.toggle("is-empty", parsedState.item_count === 0);
          const cartFooter = document.getElementById("main-cart-footer");

          if (cartFooter)
            cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
          if (cartDrawer)
            cartDrawer.classList.toggle("is-empty", parsedState.item_count === 0);

        this.renderContents(parsedState);
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

          let message = "";
          if (
              items.length === parsedState.items.length &&
              updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.FoxThemeStrings.cartError;
            } else {
              message = window.FoxThemeStrings.quantityError.replace(
                  "[quantity]",
                  updatedValue
              );
            }
          }

          this.updateLiveRegions(line, message);
          const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawer
                ? trapFocus(cartDrawer, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawer) {
            //TODO: Check later
             trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
          } else if (document.querySelector(".f-cart-item") && cartDrawer) {
            trapFocus(cartDrawer, document.querySelector(".f-cart-item__name"));
          }
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        })
        .catch(() => {
          const errors = document.querySelector(
              "#cart-errors, #CartDrawer-CartErrors"
          );
          if (errors) {
            errors.textContent = window.FoxThemeStrings.cartError;
          }
        })
        .finally(() => {
          this.loading.finish();
        });
  }

// Update renderContents to avoid calling handleArtFee during renders to prevent loops
  renderContents(parsedState) {

    // Skip rendering if we're currently processing art fees to avoid loops
    if (this.isProcessingArtFee) {
      return;
    }

    // Only render if we have sections data
    if (!parsedState || !parsedState.sections) {
      console.warn('No sections data available for rendering');
      return;
    }

    this.getSectionsToRender().forEach((section) => {

      // Check if section data exists
      if (!parsedState.sections[section.section]) {
        console.warn(`Missing section data for: ${section.section}`);
        return;
      }

      // Find the element to replace
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) {
        console.warn(`Element not found: ${section.id}`);
        return;
      }

      const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
      if (!elementToReplace) {
        console.warn(`Target element not found with selector: ${section.selector} in section: ${section.id}`);
        return;
      }

      try {
        const newHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
        );

        if (newHTML !== null) {
          elementToReplace.innerHTML = newHTML;
        } else {
          console.warn(`No HTML returned for section: ${section.section}`);
        }
      } catch (error) {
        console.error(`Error rendering section ${section.id}:`, error);
      }
    });
  }

  updateLiveRegions(line, message) {
    if (!message) return;
    const lineItemError = this.querySelector(
        `#CartItem-${line}, #CartDrawer-Item-${line}`
    );

    window.FoxTheme.Notification.show({
      target: lineItemError.querySelector(
          ".f-cart-item__quantity, .f-cart-drawer__error"
      ),
      method: "appendChild",
      type: "warning",
      message: message,
      last: 5000,
    });

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
        document.getElementById("cart-live-region-text") ||
        document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const domParser = new DOMParser().parseFromString(html, "text/html");
    return domParser.querySelector(selector)
        ? domParser.querySelector(selector).innerHTML
        : "";
  }

  enableLoading() {
    this.loading.start();
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  // Replace your simpleCartRefresh method with this version that bypasses the problematic section API:

  async simpleCartRefresh() {
    try {

      // Get fresh cart data
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error(`Cart fetch failed: ${cartResponse.status}`);
      }
      const freshCart = await cartResponse.json();

      // Update local cart reference
      this.cart = freshCart;

      // Update cart count
      if (window.FoxThemeCartHelpers && window.FoxThemeCartHelpers.updateCartCount) {
        FoxThemeCartHelpers.updateCartCount(freshCart.item_count);
      }

      // Update empty state classes
      this.classList.toggle("is-empty", freshCart.item_count === 0);

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.classList.toggle("is-empty", freshCart.item_count === 0);
      }

      const cartFooter = document.getElementById("main-cart-footer");
      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", freshCart.item_count === 0);
      }

      // Handle different page types
      if (window.FoxThemeSettings.template === "cart") {
        // For main cart page, reload the content directly
        await this.reloadMainCartContent();
      } else {
        // For other pages (cart drawer), emit basic cart update
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, freshCart);
      }

      // Handle cart drawer opening
      if (sessionStorage.getItem('openCartDrawer') === 'true') {
        sessionStorage.removeItem('openCartDrawer');
        if (cartDrawer && cartDrawer.drawer && !cartDrawer.drawer.isOpen()) {
          setTimeout(() => {
            cartDrawer.drawer.openDrawer();
            document.body.classList.add("prevent-scroll");
          }, 100);
        }
      }

    } catch (error) {
      console.error('Error in simple cart refresh:', error);
      // Only reload as last resort
      window.location.reload();
    }
  }

// New method to reload main cart content without using section API
  async reloadMainCartContent() {
    try {

      // Fetch fresh page HTML
      const response = await fetch(window.location.href + '?no-cache=' + Date.now());
      if (!response.ok) {
        throw new Error(`Page fetch failed: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update main cart items table
      const freshCartTable = doc.querySelector('#main-cart-items .js-contents');
      const currentCartTable = document.querySelector('#main-cart-items .js-contents');

      if (freshCartTable && currentCartTable) {
        currentCartTable.innerHTML = freshCartTable.innerHTML;
      } else {
        console.warn('Could not find cart table elements');
      }

      // Update cart footer if it exists
      const freshCartFooter = doc.querySelector('#main-cart-footer .js-contents');
      const currentCartFooter = document.querySelector('#main-cart-footer .js-contents');

      if (freshCartFooter && currentCartFooter) {
        currentCartFooter.innerHTML = freshCartFooter.innerHTML;
      }

      // Update cart title and item count
      const freshCartTitle = doc.querySelector('.f-cart__title-wrapper');
      const currentCartTitle = document.querySelector('.f-cart__title-wrapper');

      if (freshCartTitle && currentCartTitle) {
        currentCartTitle.innerHTML = freshCartTitle.innerHTML;
      }

      // Make sure empty state is handled correctly
      const cartItemsContainer = document.querySelector('cart-items');
      const freshCartData = await fetch('/cart.js').then(r => r.json());

      if (cartItemsContainer) {
        cartItemsContainer.classList.toggle('is-empty', freshCartData.item_count === 0);
      }


    } catch (error) {
      console.error('Error reloading main cart content:', error);
      throw error;
    }
  }

// Simplified handleArtFee that doesn't trigger complex rendering
  async handleArtFee(cart) {
    // Prevent multiple simultaneous art fee operations
    if (this.isProcessingArtFee) {
      return;
    }

    this.isProcessingArtFee = true;

    try {

      const products = this.querySelectorAll('[data-art-fee]') ||
          this.querySelectorAll('.f-cart__items .f-cart-item') ||
          this.querySelectorAll('.f-cart-drawer__items .f-cart-item') || [];

      // Calculate total art fee for all qualifying items (qty >= 2)
      let totalArtFee = 0;
      let hasQualifyingItems = false;

      Array.from(products).forEach((item) => {
        const artFeeValue = item.getAttribute("data-art-fee")?.trim();
        const quantityInput = item.querySelector('[name="updates[]"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 0 : 0;

        // Only include items with art fee AND quantity >= 2
        if (artFeeValue && artFeeValue !== "" && artFeeValue !== null && quantity >= 2) {
          const artFee = parseFloat(artFeeValue);
          if (!isNaN(artFee)) {
            totalArtFee += artFee * quantity;
            hasQualifyingItems = true;
          }
        }
      });

      const feeLineItem = cart.items.find((item) => item.id === ART_FEE_VARIANT_ID);

      function getArtFeeIndex() {
        const artFeeItem = cart.items.find(item => item.id === ART_FEE_VARIANT_ID);
        if (artFeeItem) {
          const artFeeIndex = cart.items.indexOf(artFeeItem) + 1;
          return artFeeIndex;
        }
        return null;
      }

      const artFeeIndex = getArtFeeIndex();

      if (hasQualifyingItems && totalArtFee > 0) {
        if (!feeLineItem) {
          // Add art fee product
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: ART_FEE_VARIANT_ID,
                quantity: 1
              })
            });

            if (response.ok) {
              sessionStorage.setItem('openCartDrawer', 'true');
              // Don't call simpleCartRefresh from here to avoid infinite loop
              setTimeout(() => {
                this.simpleCartRefresh();
              }, 500);
              return;
            } else {
              const errorText = await response.text();
              console.error('Failed to add art fee product:', response.status, errorText);
            }
          } catch (error) {
            console.error('Error adding art fee product:', error);
          }
        }
      } else {
        // Remove art fee product when no qualifying items
        if (feeLineItem && artFeeIndex) {
          try {
            const response = await fetch(window.FoxThemeSettings.routes.cart_change_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line: artFeeIndex,
                quantity: 0
              })
            });

            if (response.ok) {
              // Don't call simpleCartRefresh from here to avoid infinite loop
              setTimeout(() => {
                this.simpleCartRefresh();
              }, 500);
            } else {
              const errorText = await response.text();
              console.error('Failed to remove art fee product:', response.status, errorText);
            }
          } catch (error) {
            console.error('Error removing art fee product:', error);
          }
        }
      }
    } catch (error) {
      console.error('Error in handleArtFee:', error);
      // Don't reload on art fee errors, just log them
    } finally {
      this.isProcessingArtFee = false;
    }
  }





}

customElements.define("cart-items", CartItems);


